/**
 * Vuex store module for Prism text embedding and visualization.
 *
 * @module store/modules/prism
 * @description Manages state for Prism AI text embedding service and t-SNE visualization.
 * Provides actions for generating sentence embeddings and running dimensionality reduction
 * for visualizing text similarity in 2D/3D space.
 *
 * @example
 * // Access state
 * this.$store.state.prism.embedType
 *
 * // Get embeddings
 * const embeddings = await this.$store.dispatch('EMBED_SENTENCES', {
 *   sentences: ['Hello world', 'How are you']
 * });
 *
 * // Run t-SNE visualization
 * const tsneOutput = await this.$store.dispatch('RUN_TSNE', {
 *   embeddings, perplexity: 30
 * });
 */
import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { PrismState } from "./types";
import { RootState } from "@/store/types";

const prism: Module<PrismState, RootState> = {
  actions,
  mutations,
  state,
};

export default prism;
